import { LiquidityPool, LiqwidPool, OracleExternalToken, TokenPricePairConfig } from '@/src/lib/SmartDB/Commons/types';

export const LIQUIDITY_POOLS_CONFIG: LiquidityPool[] = [
    {
        name: 'ADA/MAYZ',
        address: 'addr1x94ec3t25egvhqy2n265xfhq882jxhkknurfe9ny4rl9k6dj764lvrxdayh2ux30fl0ktuh27csgmpevdu89jlxppvrst84slu',
        feePercentage: 5n,
        tokenID: {
            CS: '12fbad0ff98818ec9d75a5a1a4d54ce9cdd45cce77b84cc9b91ee896',
            TN_Hex: '4d41595a5f4144415f4e4654',
        },
        poolToken: {
            CS: '9e975c76508686eb2d57985dbaea7e3843767a31b4dcf4e99e564683',
            TN_Hex: '4d41595a',
        },
        lpTokenTestnet: {
            CS: '06b094b3f6d77d556f262cb099a6c75c6872fb2a67d13e6fe2665096',
            TN_Hex: '4c50',
        },
        lpToken: {
            CS: '9e6d0f1fd1ba193afc247f560bbb3a847b3bcfcf9689019d54b7a922',
            TN_Hex: '4d41595a5f4144415f4c51',
            amount: 9_223_372_036_854_775_807n,
        },
    },
];

export const LIQWID_POOLS_CONFIG: LiqwidPool[] = [
    {
        name: 'USDM',
        address: 'addr1wyz6rmlg2g88hnp8ugeakh6m2p9nng2w39a4vss0x0u0z0cqvh2js',
        tokenStable: {
            CS: 'c48cbb3d5e57ed56e276bc45f99ab39abe94e6cd7ac39fb402da47ad',
            TN_Hex: '0014df105553444d',
        },
        tokenStableLiqwidTestnet: {
            CS: 'fb3cec684bc96575f4ba6ed7f11b1547114d7af41a9f38e552bcfbd2',
            TN_Hex: '5553444d',
        },
        tokenStableLiqwid: {
            CS: '9e00df0615de0a7b121a7f961d43e23165b8e81b64786c6eb708d370',
            TN_Hex: '',
        },

        tokenMarketStateID: {
            CS: 'dae2eab1798b6a6184c34e305faf7b04c325201f9a24535b98ddbf8b',
            TN_Hex: '',
        },
    },
    {
        name: 'USDA',
        address: 'addr1wyrauh45lkuld0frc77rckyrqmcr63kgck0wnqpzxyevsls4qsrls',
        tokenStable: {
            CS: 'fe7c786ab321f41c654ef6c1af7b3250a613c24e4213e0425a7ae456',
            TN_Hex: '55534441',
        },
        tokenStableLiqwidTestnet: {
            CS: '56eed92f51ef021905dc35745cf5c4a9aec5362746714e0a70a2b977',
            TN_Hex: '55534441',
        },
        tokenStableLiqwid: {
            CS: 'aa280c98c5b07fdfc8d7a93fb5ba84510b421388e4a18e16efa8eb5f',
            TN_Hex: '',
        },
        tokenMarketStateID: {
            CS: '9330ff6f3d301a9abc1979cffd1465cd27f7563837a7d635f59f1aa2',
            TN_Hex: '',
        },
    },
    {
        name: 'iUSD',
        address: 'addr1w94gxm5tksyw75gs5arhqwdf7h7yre2ma878ad2xfhhcy6cq7q4tp',
        tokenStable: {
            CS: 'f66d78b4a3cb3d37afa0ec36461e51ecbde00f26c8f0a68f94b69880',
            TN_Hex: '69555344',
        },
        tokenStableLiqwidTestnet: {
            CS: '02c44e42ff5341c8ee6d7df47dd5883b6cae9d4bf818f495770c323c',
            TN_Hex: '69555344',
        },
        tokenStableLiqwid: {
            CS: 'd15c36d6dec655677acb3318294f116ce01d8d9def3cc54cdd78909b',
            TN_Hex: '',
        },
        tokenMarketStateID: {
            CS: '416109f322b43051b80e83075b4baa8c5af14c88acaca47d5c251820',
            TN_Hex: '',
        },
    },
    {
        name: 'DJED',
        address: 'addr1w85g7uhkk3nnmduwlc2gk8xep35fz9wak0t7x44qqqc53ncahh4lz',
        tokenStable: {
            CS: '8db269c3ec630e06ae29f74bc39edd1f87c819f1056206e879a1cd61',
            TN_Hex: '446a65644d6963726f555344',
        },
        tokenStableLiqwidTestnet: {
            CS: '20cb1014abfdbd29b6d5beaffe693d1bac77b8647d0769f1e58dbbb6',
            TN_Hex: '446a65644d6963726f555344',
        },
        tokenStableLiqwid: {
            CS: '6df63e2fdde8b2c3b3396265b0cc824aa4fb999396b1c154280f6b0c',
            TN_Hex: '',
        },
        tokenMarketStateID: {
            CS: '43c4bdac04537dbd338935d00a8a0746a078d4f03d7ac302a4bf5d3d',
            TN_Hex: '',
        },
    },
];

const rawTokensEXTERNAL_ORACLE = process.env.NEXT_PUBLIC_TOKENS_EXTERNAL_ORACLE;
const cleanTokensEXTERNAL_ORACLE = rawTokensEXTERNAL_ORACLE?.replace(/\\"/g, '"');
export const TOKENS_EXTERNAL_ORACLE_CONFIG: OracleExternalToken[] = cleanTokensEXTERNAL_ORACLE ? JSON.parse(cleanTokensEXTERNAL_ORACLE) : [];

const rawTokenPricePairs = process.env.NEXT_PUBLIC_PRICE_TOKENS_PAIRS;
const cleanTokenPricePairs = rawTokenPricePairs?.replace(/\\"/g, '"');
export const PRICE_TOKENS_PAIRS_CONFIG: TokenPricePairConfig[] = cleanTokenPricePairs ? JSON.parse(cleanTokenPricePairs) : [];
